<template>
	<div class="news">
		<!-- banner -->
		<div class="banner">
			<div class="banner_text">
				<p>标识资讯</p>
				<p>Identification information</p>
			</div>
			<img v-if="banner" :src="banner" alt="" />
			<img v-else src="./../../assets/images/home/news_banner.png" alt="" />
		</div>
		<div class="list_wrap">
			<div class="search">
				<el-form :inline="true" :model="form" class="search_form">
					<div class="form_left">
						<el-form-item label="开始时间-结束时间">
							<el-date-picker
								v-model="dataTime"
								type="daterange"
								format="yyyy-MM-dd"
								value-format="yyyy-MM-dd"
								range-separator="至"
								start-placeholder="开始时间"
								end-placeholder="结束时间"
							></el-date-picker>
						</el-form-item>
					</div>
					<div class="form_right">
						<el-form-item label="">
							<el-input v-model="form.keywords" placeholder="请输入标题" style="width: 200px"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button @click="acticleList">搜索</el-button>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div class="list-box">
				<ul class="list">
					<li v-for="item in newsData" :key="item.id">
						<div class="left">
							<h3 @click="goToDetails(item.id)">{{ item.title }}</h3>
							<p>{{ item.remark }}</p>
						</div>
						<div class="right">{{ item.addTime }}</div>
					</li>
				</ul>
			</div>

			<div class="pagination_style">
				<span>
					第 {{ pagination.page == 1 ? 1 : (pagination.page - 1) * pagination.size + 1 }} -
					{{ pagination.page * pagination.size >= listInfo ? listInfo : pagination.page * pagination.size }} 条/总共 {{ listInfo }} 条
				</span>
				<el-pagination
					background
					class="pagin_cont"
					layout="prev, pager, next"
					:total="pagination.total"
					:current-page="pagination.page"
					:page-size="pagination.size"
					@current-change="currentChange"
					@size-change="sizeChange"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { acticleList } from '@/api/home';
import { dataPaging } from '@/utils/until.js';
export default {
	name: 'News',
	data() {
		return {
			newsAllData: [], // 新闻动态全部数据
			newsData: [], //新闻动态
			form: {
				keywords: '', //模糊查询
				startTime: '', //开始时间
				endTime: '' //截止时间
			},
			dataTime: [], //时间
			banner: '',
			limitList: '',
			listInfo: '',
			pagination: {
				total: 0,
				page: 1,
				size: 5
			}
		};
	},
	mounted() {
		// 新闻动态--栏目id：1  应用领域--栏目id：2  关于我们--栏目id：3 banner图--栏目id：4
		this.acticleList();
		this.banner = this.$route.query.banner || '';
	},
	methods: {
		acticleList() {
			//通过栏目id获取内容列表
			if (this.dataTime && this.dataTime.length != 0) {
				this.form.startTime = this.dataTime[0];
				this.form.endTime = this.dataTime[1];
			} else {
				this.form.startTime = '';
				this.form.endTime = '';
			}
			const loading = this.$loading({
				lock: true,
				text: '拼命加载中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			acticleList({
				columnId: this.$route.query.id, //栏目id 4
				...this.form,
				page: this.pagination.page, //页码
				limit: this.pagination.size //分页大小
			})
				.then((res) => {
					// console.log('新闻动态');
					// console.log(JSON.parse(JSON.stringify(res.data)))
					this.newsData = res.data.list || [];
					this.listInfo = res.data.total;
					this.pagination.total = res.data.total;
					// this.newsAllData = res.data || [];
					// this.pagination.total = this.newsAllData.length;
					// this.dataPagination();
					loading.close();
				})
				.catch(() => {
					loading.close();
				});
		},
		// 数据分页
		dataPagination() {
			this.newsData = dataPaging(this.newsAllData, this.pagination);
		},
		currentChange(val) {
			this.pagination.page = val;
			this.acticleList();
		},
		sizeChange(val) {
			this.pagination.page = 1;
			this.pagination.size = val;
			this.acticleList();
		},
		goToDetails(id) {
			//查看文章详情
			let pathInfo = this.$router.resolve({
				path: '/details/' + id
			});
			window.open(pathInfo.href, '_blank');
		}
	}
};
</script>
<style lang="scss" scoped>
.news {
	width: 100%;
	height: 100%;
	overflow: hidden auto;
	padding-bottom: 84px;
	box-sizing: border-box;
	.banner {
		width: 100%;
		position: relative;
		font-size: 0;
		.banner_text {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 1200px;
			// border: 1px solid #0f0;
			p:nth-child(1) {
				font-size: 30px;
				color: #333;
			}
			p:nth-child(2) {
				font-size: 24px;
				color: #c9ece1;
				margin-top: 15px;
				// width: 640px;
				color: #333;
				line-height: 41px;
			}
		}
		img {
			width: 100%;
			max-height: 400px;
		}
	}
	.list_wrap {
		// border:1px solid #f00;
		width: 100%;
		.search {
			width: 100%;
			// border:1px solid #0f0;
			height: 60px;
			background-color: #fafafa;
			.search_form {
				width: 1200px;
				border-radius: 5px;
				// border: 1px solid #f0f;
				margin: 0 auto;
				padding: 25px 30px 0;
				box-sizing: border-box;
				background-color: #fff;
				position: relative;
				bottom: 45px;
				display: flex;
				justify-content: space-between;
				::v-deep {.el-form-item__label {
					font-weight: 700;
				}
			}
				.el-button {
					background-color: #006300;
					font-size: 18px;
					color: #fff;
					border: none;
				}
				.el-form-item {
					vertical-align: middle;
				}
				// .form_left{

				// }
				// .form_right{

				// }
			}
		}
		.list-box {
			width: 1200px;
			height: 300px;
			overflow: hidden;
			margin: 0 auto 80px;
			
			.list {
				width: 100%;
				height: 100%;
				padding: 0 20px 0 0;
				overflow: auto;
				
				& > li {
					display: flex;
					padding: 40px 0;
					box-sizing: border-box;
					border-bottom: 1px solid #f2f2f2;
					.left {
						// border:1px solid #f00;
						flex: 1;
						margin-right: 25px;
						h3 {
							color: rgba(0, 0, 0, 0.9);
							font-size: 16px;
							cursor: pointer;
							word-break: break-all;
						}
						h3:hover {
							color: #047704; /* 鼠标悬浮时的颜色 */
						}
						p {
							color: rgba(102, 102, 102, 0.9);
							line-height: 20px;
							font-size: 14px;
							margin-top: 20px;
							word-break: break-all;
						}
					}
					.right {
						// border:1px solid #0f0;
						flex: none;
						width: 140px;
						text-align: center;
						color: rgba(102, 102, 102, 0.9);
						font-size: 14px;
					}
				}
			}
		}

		.pagination_style {
			display: flex;
			align-items: center;
			justify-content: center;
			margin-top: 16px;
			margin-bottom: 16px;
			// ::v-deep {
			// 	.el-pager li.active {
			// 		border: 1px solid #00aa73;
			// 		color: #00aa73;
			// 	}
			// 	.el-pager li:hover {
			// 		color: #00aa73;
			// 	}
			// }
		}
	}
}
</style>
